/** Browsing history of stock detail pages. Device-local only (docs/01-requirements.md S-5). */

const KEY = "yct.viewHistory.v1";
const LIMIT = 100;

export interface ViewHistoryEntry {
  stockCode: string;
  viewedAt: string;
}

function read(): ViewHistoryEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as ViewHistoryEntry[]) : [];
  } catch {
    return [];
  }
}

function write(entries: ViewHistoryEntry[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(entries));
  } catch {
    // Storage may be unavailable (private mode); history is a convenience only.
  }
}

export function recordView(stockCode: string, now = new Date()): ViewHistoryEntry[] {
  const next = [{ stockCode, viewedAt: now.toISOString() }, ...read().filter((e) => e.stockCode !== stockCode)].slice(0, LIMIT);
  write(next);
  return next;
}

export function getViewHistory(): ViewHistoryEntry[] {
  return read();
}

export function clearViewHistory(): void {
  write([]);
}
